import React from "react";
import ReactDOM from "react-dom/client";
import "@fontsource/kanit/latin-300.css";
import "@fontsource/kanit/latin-400.css";
import "@fontsource/kanit/latin-500.css";
import "@fontsource/kanit/latin-600.css";
import "@fontsource/kanit/latin-700.css";
import App from "./App";
import "./index.css";

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
